// extracted by mini-css-extract-plugin
export default {"banner-content-module":"banner-content-module--WqGdm","bannerContentModule":"banner-content-module--WqGdm"};